
import { TweenMax,gsap, Expo,Power3,TimelineMax} from "gsap/all";
import anime from 'animejs/lib/anime.es.js';
 

export const animateSingleProjectModal = () => {
      TweenMax.to(".box", 2.4, {
            y: "-100%",
            ease: Expo.easeInOut,
            delay: 1,
          });
          
          TweenMax.from("img", 4, {
            scale: "2",
            ease: Expo.easeInOut,
            delay: 0,
          });
          
          TweenMax.to(".wrapper-img", 2.4, {
            width: "300",
            height: "400",
            ease: Expo.easeInOut,
            delay: 3.6,
          });
          
          TweenMax.from(".img", 0.4, {
            // opacity: 0,
            ease: Expo.easeInOut,
            delay: 3.4,
          });
          
          TweenMax.to(".left", 2, {
            x: "-300",
            rotation: -10,
            scale: ".75",
            ease: Expo.easeInOut,
            delay: 3.8,
          });
          
          TweenMax.to(".right", 2, {
            x: "0",
            rotation: 10,
            scale: ".75",
            ease: Expo.easeInOut,
            delay: 3.8,
          });
          
          TweenMax.staggerFrom(
            ".menu > div, .hero-container > div",
            2,
            {
              opacity: 0,
              y: 30,
              ease: Expo.easeInOut,
              delay: 4.2,
            },
            0.1
          );

}
export const animateLetters = () => {
    var t1 = new TimelineMax();

    t1.to(".letterToFloat.first", 1, { 
          y:20,
          ease: Expo.easeInOut
    }).to(".letterToFloat.first", 1, { 
        x: "1155%",
          rotation: 360,
          ease: Expo.easeInOut
    }).to(".letterToFloat.first", 1, { 
        y:0,
          ease: Expo.easeInOut
    });
   
    var t2 = new TimelineMax();

    t2.to(".letterToFloat.last", 1, { 
          y:-20,
          ease: Expo.easeInOut
    }).to(".letterToFloat.last", 1, { 
          x: "-1155%",
          rotation: 360,
          ease: Expo.easeInOut
    }).to(".letterToFloat.last", 1, { 
        y:0,
          ease: Expo.easeInOut
    });
  
}

export const animateLettersReverse = () => {
      gsap.set(".letterToFloat.first", {
             y: 0,
             x: 0,
             ease: Expo.easeInOut
        });
        gsap.set(".letterToFloat.last", {
            y: 0,
            x: 0,
            ease: Expo.easeInOut
       });
}
export const tweenAnimationSequence : () => void = () =>{
    TweenMax.to(".loading-screen", 4, {
        delay: 5.4,
        top: "-110%",
        ease: Expo.easeInOut
  });

  TweenMax.from(".logo", 3, {
        delay: 6.5,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from(".contacthead", 3, {
        delay: 6.5,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from(".options", 3, {
        delay: 6.4,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from(".bottom-text", 3, {
        delay: 6.7,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from(".copyright", 3, {
        delay: 6.8,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.staggerFrom(".media ul li", 2, {
        delay: 7.7,
        opacity: 0,
        y: 20,
        ease: Power3.easeInOut
  }, 0.1);

  TweenMax.from(".menu", 3, {
        delay: 6.8,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from(".p1", 3, {
        delay: 7,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from(".p2", 3, {
        delay: 7.2,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut
  });

  TweenMax.from("#one", 2, {
        delay: 7.4,
        opacity: 0.1,
        y: 20,
        ease: Expo.easeInOut,
        cursor: "pointer"
  });

  TweenMax.from("#two", 3, {
        delay: 7.7,
        opacity: 0,
        y: 20,
        ease: Expo.easeInOut,
        cursor: "pointer"
  });

  var t1 = new TimelineMax();

  t1.from(".ringOne", 4, {
        delay: .5,
        opacity: 0,
        y:140,
        ease: Expo.easeInOut
  }).from(".ringTwo", 4, {
    delay: .9,
        opacity: 0,
        y: 140,
        ease: Expo.easeInOut
  }, "-=5").to(".ringOne", 4, {
    delay: 0.4,
        x: "50%",
        ease: Expo.easeInOut
  }).to(".ringTwo", 4, {
    delay: .9,
        x: "50%",
        ease: Expo.easeInOut
  },"-=5");
 

  anime.timeline({loop: false})
  .add({
    targets: '.ml7 .letter',
    translateY: ["1.1em", 0],
    translateX: ["0.55em", 0],
    translateZ: 0,
    rotateZ: [180, 0],
    duration: 750,
    easing: "easeOutExpo",
    delay: function(el, i) {
      return 9000 + 50 * i;
    }
  });
}